import { render, staticRenderFns } from "./CoberturaParticipantes.vue?vue&type=template&id=3a3ff531&scoped=true&"
import script from "./CoberturaParticipantes.vue?vue&type=script&lang=js&"
export * from "./CoberturaParticipantes.vue?vue&type=script&lang=js&"
import style0 from "./CoberturaParticipantes.vue?vue&type=style&index=0&id=3a3ff531&scoped=true&lang=css&"
import style1 from "./CoberturaParticipantes.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3ff531",
  null
  
)

export default component.exports